import {Component, OnInit} from '@angular/core';
import {ScullyRoute, ScullyRoutesService} from '@scullyio/ng-lib';
import {map, take} from 'rxjs/operators';
import {Title} from "@angular/platform-browser";

declare var $: any;

@Component({
  selector: 'app-media-list',
  templateUrl: './media-list.component.html',
  styleUrls: ['./media-list.component.scss']
})
export class MediaListComponent implements OnInit {
  media$ = this.srs.available$.pipe(
    map(routeList =>
      routeList.filter((route: ScullyRoute) => route.route.startsWith(`/media/`))
    ),
    map(pages => pages.sort((a, b) => (a.published_at > b.published_at ? -1 : 1)))
  );

  public spotlight$

  constructor(private srs: ScullyRoutesService, private titleService: Title) {
  }

  async ngOnInit() {
    this.titleService.setTitle("Media | MatchMove")
    this.spotlight$ = (await this.media$.pipe(take(1)).toPromise())[0]
  }
}
